import api from './api';
import { Document, CompanyDocument, UserDocument, CompanyDocumentForm, UserDocumentForm } from '../types';

export const documentsService = {
  // Получить все типы документов
  async getDocuments(): Promise<Document[]> {
    const response = await api.get('/api/documents/');
    return response.data;
  },

  // Получить документы компании
  async getCompanyDocuments(companyId: number): Promise<CompanyDocument[]> {
    const response = await api.get(`/api/company-documents/company/${companyId}`);
    return response.data;
  },

  // Создать документ компании
  async createCompanyDocument(companyId: number, document: CompanyDocumentForm): Promise<CompanyDocument> {
    const response = await api.post('/api/company-documents/', {
      company_id: companyId,
      ...document
    });
    return response.data;
  },

  // Обновить документ компании
  async updateCompanyDocument(id: number, document: Partial<CompanyDocumentForm>): Promise<CompanyDocument> {
    const response = await api.put(`/api/company-documents/${id}`, document);
    return response.data;
  },

  // Удалить документ компании
  async deleteCompanyDocument(id: number): Promise<void> {
    await api.delete(`/api/company-documents/${id}`);
  },

  // Получить документы пользователя
  async getUserDocuments(userId: number): Promise<UserDocument[]> {
    const response = await api.get(`/api/user-documents/user/${userId}`);
    return response.data;
  },

  // Создать документ пользователя
  async createUserDocument(userId: number, document: UserDocumentForm): Promise<UserDocument> {
    const response = await api.post('/api/user-documents/', {
      user_id: userId,
      ...document
    });
    return response.data;
  },

  // Обновить документ пользователя
  async updateUserDocument(id: number, document: Partial<UserDocumentForm>): Promise<UserDocument> {
    const response = await api.put(`/api/user-documents/${id}`, document);
    return response.data;
  },

  // Удалить документ пользователя
  async deleteUserDocument(id: number): Promise<void> {
    await api.delete(`/api/user-documents/${id}`);
  },

  // Загрузить файл документа компании
  async uploadCompanyDocument(
    companyId: number,
    documentId: number,
    file: File,
    notes?: string,
    expiresAt?: string | null
  ): Promise<CompanyDocument> {
    const formData = new FormData();
    formData.append('company_id', companyId.toString());
    formData.append('document_id', documentId.toString());
    formData.append('file', file);
    if (notes) {
      formData.append('notes', notes);
    }
    if (expiresAt) {
      formData.append('expires_at', expiresAt);
    }
    const response = await api.post('/api/company-documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Загрузить файл документа пользователя
  async uploadUserDocument(
    userId: number,
    documentId: number,
    file: File,
    notes?: string,
    expiresAt?: string | null
  ): Promise<UserDocument> {
    const formData = new FormData();
    formData.append('user_id', userId.toString());
    formData.append('document_id', documentId.toString());
    formData.append('file', file);
    if (notes) {
      formData.append('notes', notes);
    }
    if (expiresAt) {
      formData.append('expires_at', expiresAt);
    }
    const response = await api.post('/api/user-documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
